import { render, staticRenderFns } from "./Ecommerce.vue?vue&type=template&id=20bcc197&scoped=true&"
import script from "./Ecommerce.vue?vue&type=script&lang=js&"
export * from "./Ecommerce.vue?vue&type=script&lang=js&"
import style0 from "./Ecommerce.vue?vue&type=style&index=0&id=20bcc197&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bcc197",
  null
  
)

export default component.exports